class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tabsElement = this.querySelector('[data-tabs]');

    // Default to improve user experience
    this.options = {};

    // Check if we have extra options on the HTML
    if (this.dataset.options) {
      const options = JSON.parse(this.dataset.options);
      if (options) {
        this.options = {
          ...this.options,
          ...options
        }
      }
    }

    // Catch click on desktop tab navigation
    this.tabsElement.querySelectorAll('[data-tabs-link]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      this.linkClick(link);
    }));

    // Catch click on mobile tab navigation
    this.tabsElement.querySelectorAll('[data-tabs-mobile-link]').forEach(mobLink => mobLink.addEventListener('click', event =>{
      event.preventDefault();
      this.mobLinkClick(mobLink);
    }));

    // Open tab from url hash
    if(this.options.openFromHash && window.location.hash) {
      this.tabsElement.querySelector(`[data-tabs-link="${ window.location.hash.substring(1) }"]`).click();
    }

    // In the theme customiser, re-open the tab after each block-edit / section reload
    if (Shopify.designMode) {
      const openTab = sessionStorage.getItem("openTab");
      const targetTab = this.tabsElement.querySelector(`[data-tabs-link="${openTab}"]`)
      if (targetTab) {
        targetTab.click();
      }
    }
  }

  // mobile
  mobLinkClick(mobLink) {
    const title = mobLink.dataset.tabsMobileLink;

    // Only do something when the tab is not active
    if (!mobLink.classList.contains('is-active')) {

      // Close the active tab and open the clicked tab after that
      this.closeActiveTab(title);

      // Open the clicked tag link
      this.openTabNavLink(title);
    } else {
      // Close the active tab
      this.closeCurrentTab(title);
    }
  }

  // desktop
  linkClick(link) {
    const title = link.dataset.tabsLink;

    // Only do something when the tab is not active
    if (!link.classList.contains('is-active')) {

      // Close the active tab and open the clicked tab after that
      this.closeActiveTab(title);

      // Open the clicked tag link
      this.openTabNavLink(title);
    }
  }

  closeActiveTab(title) {
    const activeTab = this.tabsElement.querySelector('.is-active');
    // If there is an active tab
    if (activeTab) {
      // Get title
      const activeTitle = activeTab.dataset.tabsLink;
      // Don't reopen self
      if (activeTitle === title) {
        return;
      }

      this.closeTab(activeTitle);
      this.closeTabNavLink(activeTitle);
    }

    this.openTab(title);
  }

  closeCurrentTab(title) {
    const activeTab = this.tabsElement.querySelector('.is-active');
    // If there is an active tab
    if (activeTab) {

      // Get title
      const activeTitle = activeTab.dataset.tabsLink;

      // Close current tab
      this.closeTab(activeTitle);
    }
  }

  closeTab(title) {
    // Close the tab and tab link content
    this.tab =  this.tabsElement.querySelector('[data-tabs-link="' + title + '"]');
    this.mobTab = this.tabsElement.querySelector('[data-tabs-mobile-link="' + title + '"]');
    this.tabContent = this.tabsElement.querySelector('[data-tabs-content-pane="' + title + '"]');
    if (this.tab) {
      this.tab.classList.remove('is-active');
      this.tabContent.classList.remove('is-active');
    }
    if (this.mobTab) {
      this.mobTab.classList.remove('is-active');
      this.tabContent.classList.remove('is-active');
    }
  }

  closeTabNavLink(title) {
    // Close the tab link in nav
    this.tab =  this.tabsElement.querySelector('[data-tabs-link="' + title + '"]');
    this.mobTab = this.tabsElement.querySelector('[data-tabs-mobile-link="' + title + '"]');
    if (this.tab) {
      this.tab.classList.remove('is-active');
    }
    if (this.mobTab) {
      this.mobTab.classList.remove('is-active');
    }
  }

  openTab(title) {
    // Open new tab and the tab content
    this.tabsElement.querySelector('[data-tabs-content-pane="' + title + '"]').classList.add('is-active');
    this.tabsElement.querySelector('[data-tabs-link="' + title + '"]').classList.add('is-active');
    this.tabsElement.querySelector('[data-tabs-mobile-link="' + title + '"]').classList.add('is-active');
  }

  openTabNavLink(title) {
    // Open new tab
    this.tabsElement.querySelector('[data-tabs-link="' + title + '"]').classList.add('is-active');
    this.tabsElement.querySelector('[data-tabs-mobile-link="' + title + '"]').classList.add('is-active');

    // Store open tab so it can be reopened after block edit / section reload
    if (Shopify.designMode) {
      sessionStorage.setItem("openTab", title);
    }
  }


}
customElements.define('product-tabs', ProductTabs);
